/*
 * Do not update this file manually.
 * It is automatically generated from /scripts/generate-contentful-types.ts
 */
import type {
    ChainModifiers,
    Entry,
    EntryFieldTypes,
    EntrySkeletonType,
    LocaleCode,
} from 'contentful'
import type { TypeTdCustomPageButtonSkeleton } from './TypeTdCustomPageButton'

export interface TypeTdCustomPagePrefooterTwoColumnFields {
    name: EntryFieldTypes.Symbol
    title?: EntryFieldTypes.Symbol
    theme: EntryFieldTypes.Symbol<'green' | 'neutral' | 'red' | 'seaSalt' | 'white' | 'yellow'>
    button?: EntryFieldTypes.EntryLink<TypeTdCustomPageButtonSkeleton>
    includeCustomerLogos: EntryFieldTypes.Boolean
    leftColumnTitle?: EntryFieldTypes.Symbol
    leftColumnSubtitle?: EntryFieldTypes.Symbol
    leftColumnButton?: EntryFieldTypes.EntryLink<TypeTdCustomPageButtonSkeleton>
    rightColumnImage?: EntryFieldTypes.AssetLink
}

export type TypeTdCustomPagePrefooterTwoColumnSkeleton = EntrySkeletonType<
    TypeTdCustomPagePrefooterTwoColumnFields,
    'tdCustomPagePrefooterTwoColumn'
>
export type TypeTdCustomPagePrefooterTwoColumn<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTdCustomPagePrefooterTwoColumnSkeleton, Modifiers, Locales>

export function isTypeTdCustomPagePrefooterTwoColumn<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode,
>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTdCustomPagePrefooterTwoColumn<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'tdCustomPagePrefooterTwoColumn'
}
